var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-videohistory-stream__state mc-videohistory-stream__state--connecting"},[_c('div',[_vm._v(_vm._s(_vm.$t('trackVideo.connecting'))+" ...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }